import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';


import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { CheckoutTimeoutComponent } from './timeout.component';
import { TimeoutService } from 'src/app/shared/services/timeout-data.service';
import { MobileDropdownModule } from 'src/app/shared/components/mobile-dropdown/mobile-dropdown.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        MatSnackBarModule,
        MobileDropdownModule
    ],
  exports: [
    CheckoutTimeoutComponent
  ],
  providers: [
    BreadcrumbService,
    TimeoutService
  ],
  declarations: [
    CheckoutTimeoutComponent
  ]
})
export class CheckoutTimeoutModule { }
